<template>

    <select class="c-select2">
        <slot></slot>
    </select>

</template>


<script>

import VSelect from 'vue-select'
import $ from 'jquery'
import 'select2'
import pl from "select2/src/js/select2/i18n/pl"

export default {

    name: 'VSelect2',

    props: ['options', 'value', 'ajaxUrl', 'formatItem'],

    watch: {
        value: function (value) {
            // update value
            $(this.$el)
                .val(value)
                .trigger('change')
        },
        options: function (options) {
            // update options
            if (options) {
                $(this.$el).empty().select2({data: options})
            }
        },
        ajaxUrl: function (ajaxUrl) {

            // update ajax
            if (ajaxUrl) {
                $(this.$el).empty().select2({
                    ajax: {
                        url: ajaxUrl,
                        delay: 250,
                        dataType: 'json',
                    },
                    templateResult: this.formatItem,
                    templateSelection: this.formatItem,
                })
            }

        }
    },

    mounted: function () {
        var vm = this
        $.fn.select2.defaults.set('language', pl)

        let config;
        if (this.ajaxUrl) {
            config = {
                ajax: {
                    url: this.ajaxUrl,
                    dataType: 'json'
                }
            }
        } else {
            config = {
                data: this.options,
                width: '100%'
            }
        }
        $(this.$el)
            // init select2
            .select2(config)
            .val(this.value)
            .trigger('change')
            // emit event on change.
            .on('change', function () {
                vm.$emit('input', this.value)
            })
    },

    destroyed: function () {
        $(this.$el).off().select2('destroy')
    }

}

</script>


<style lang="scss">

.c-select2 {

}


</style>
